import React, { useState, useRef } from 'react';
import styled from 'styled-components';

interface VideoPlayerProps {
    src: string;
    poster?: string;
}

const VideoContainer = styled.div`
    width: 100%;
    position: relative;
    padding-top: 56.25%; /* 16:9 aspect ratio */
    background: #000;

    video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #000;

        &::-webkit-media-controls-start-playback-button {
            display: none !important;
        }
    }
`;

const PosterOverlay = styled.div<{ $show: boolean }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${(props) => props.about});
    background-size: cover;
    background-position: center;
    pointer-events: ${(props) => (props.$show ? 'auto' : 'none')};
    opacity: ${(props) => (props.$show ? 1 : 0)};
    transition: opacity 0.3s ease;
    z-index: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover .play-button {
        transform: scale(1.1);
        background-color: rgba(255, 255, 255, 0.95);
    }
`;

const PlayButton = styled.div`
    width: 80px;
    height: 80px;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);

    &::after {
        content: '';
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 15px 0 15px 26px;
        border-color: transparent transparent transparent #000;
        margin-left: 6px;
    }
`;

export const VideoPlayer: React.FC<VideoPlayerProps> = ({ src, poster }) => {
    const [showPoster, setShowPoster] = useState(true);
    const videoRef = useRef<HTMLVideoElement>(null);

    const handlePlay = () => {
        setShowPoster(false);
    };

    const handlePosterClick = () => {
        if (videoRef.current) {
            videoRef.current.play();
            setShowPoster(false);
        }
    };

    return (
        <VideoContainer>
            {poster && showPoster && (
                <PosterOverlay $show={showPoster} about={poster} onClick={handlePosterClick}>
                    <PlayButton className="play-button" />
                </PosterOverlay>
            )}
            <video ref={videoRef} controls preload="metadata" onPlay={handlePlay}>
                <source src={src} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </VideoContainer>
    );
};
